export enum LiveStreamingStates {
  WAS_LIVE = 'was-livestreaming',
  IS_LIVE = 'livestreaming',
  PLANNED = 'planned',
  UNKNOWN = 'unknown',
}
